import React from 'react';
import './Skeleton.css';

const normalizeSize = (value) => (typeof value === 'number' ? `${value}px` : value);

export const Skeleton = ({ width = '100%', height = 14, radius = 'md', className = '' }) => (
  <span
    className={`skeleton skeleton-${radius} ${className}`.trim()}
    style={{ width: normalizeSize(width), height: normalizeSize(height) }}
    aria-hidden="true"
  />
);

export const SkeletonTable = ({ rows = 5, columns = 4, className = '' }) => (
  <div className={`skeleton-table ${className}`.trim()} aria-label="Loading" role="status">
    {Array.from({ length: rows }).map((_, rowIndex) => (
      <div key={`row-${rowIndex}`} className="skeleton-table-row">
        {Array.from({ length: columns }).map((__, colIndex) => (
          <Skeleton key={`cell-${rowIndex}-${colIndex}`} height={12} width={`${Math.max(35, 100 - colIndex * 14)}%`} />
        ))}
      </div>
    ))}
  </div>
);

export default Skeleton;
